<form [formGroup]='formGroup'>
  <div class='form-group input-select-container'>
    <label [htmlFor]='inputId' [innerHTML]='label' class="form-label"></label>
    <select [id]='inputId' class='form-control form-control-sm' formControlName='value'>
      <option *ngFor='let option of options' [value]='option.value'>
        {{ option.label | async }}
      </option>
    </select>
  </div>
</form>
